import { Localization } from "@abcya/abcya_phaser";
import AScene from "../../library/ExtendedObjects/AScene.js";
import Utils from "../../library/Utils.js";
import Game from "../game/Game.js";

export default class Intro extends AScene
{
    static get KEY() { return 'Intro'; }
    constructor()
    {
        super({ key: (Intro).KEY });
    }

    create()
    {
        this.background = this.addImage(this.mid.x, this.mid.y, "Background");
        this.title = this.addImage(this.mid.x + 245, this.mid.y + 116, "HoldThePhone");
        this.description = this.addImage(this.mid.x - 203, this.mid.y + 90, "AnIdiomGame");
        this.playButton = this.addButton(this.mid.x, this.mid.y + 390, "PlayButton", {tintOnDown: 0xaaaaaa}, ()=>{
            Utils.TransitionScenes(this, Game.KEY, 700, 1, 0, Phaser.Math.Easing.Sine.InOut);
            this.addTween(this.introSound, 200, {volume: 0}, Phaser.Math.Easing.Sine.Out);
        });

        this.title.setScale(0);
        this.description.setScale(0);
        this.playButton.setScale(2.5, 2);
        
        this.title.alpha = 0;
        this.description.alpha = 0;
        this.playButton.alpha = 0;

        this.addTween(this.title, 1500, {scaleX: 1, scaleY: 1, easeParams: [1, 1], alpha: 1}, "Elastic");
        this.addTween(this.description, 1500, {scaleX: 1, scaleY: 1, easeParams: [1, 1], alpha: 1, delay: 500}, "Elastic");
        this.addTween(this.playButton, 1500, {scaleX: 1, scaleY: 1, easeParams: [1, 1], alpha: 1, delay: 1000}, "Elastic");

        this.introSound = this.playSound("jingle_hold_the_phone");

    }
}